import React from 'react';
import AdvancedList from './advancedList/AdvancedList';

const TableList = props => <AdvancedList {...props} />;

export default TableList;
